<template>
	<module-field :bind="$props">
		<span class="input-box">
			<masked-input type="text" :mask="mask" v-model="inputVal" :guide="false" :placeholder="field.placeholder"></masked-input>
		</span>
	</module-field>
</template>

<script>
// import CrudField from '@/mixins/CrudField';
import CrudField from '@/mixins/CrudField';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default {
	mixins: [ CrudField ],

	data() {
		return {
			decimals: 2,
			type: '',
		};
	},

	mounted() {
		if (this.field.specific_data.indexOf(',') !== -1) {
			const [ decimals, type ] = this.field.specific_data.split(',');
			this.decimals = decimals;
			this.type = type;
		}
	},

	computed: {

		mask() {
			let settings = {
				prefix: '',
				suffix: '',
				decimalSymbol: '.',
				decimalLimit: parseInt(this.decimals, 10),
				allowDecimal: this.decimals > 0,
			};

			switch (this.type.toLowerCase()) {
				case 'percent':
					settings.suffix = '%';
					break;
				case 'currency':
					settings.prefix = '$';
					settings.allowDecimal = true;
					break;
				default:
					settings.prefix = '';
					settings.suffix = '';
					settings.allowDecimal = true;
					break;
			}

			return createNumberMask(settings);
		}
	}
};
</script>
